export const isMale = (val) => {
    return ['Male','male','M'].includes(val);
};
export const isFemale = (val) => {
    return ['Female','female','FM','F'].includes(val)
};